import { Mesh, Object3D, Scene, WebGLRenderer, WebGLRenderTarget } from "three";

export class ThreeUtils {
    static getScene(object: Object3D | Scene): Scene | null {
        if ("isScene" in object) return object as Scene;
        while (object.parent !== null) {
            object = object.parent;
            if ("isScene" in object) return object as Scene;
        }
        return null;
    }

    static traversePath(object: Object3D, callback: (object: Object3D, path: string) => void) {
        function traverse(obj: Object3D, base: string) {
            callback(obj, base);
            for (let i = 0; i < obj.children.length; ++i) {
                const path = `${base}${base.length > 0 ? "-":""}children-${i}`;
                traverse(obj.children[i], path);
            }
        }
        traverse(object, "");
    }

    static isChildOf(child: any, parent: any) {
        if (child === parent) return false;
        while (child.parent !== null) {
            child = child.parent;
            if (child === parent) return true;
        }
        return false;
    }

    static toDataURL(renderer: WebGLRenderer, rt: WebGLRenderTarget) {
        // Read pixels into array
        const data = new Uint8Array(rt.width * rt.height * 4);
        renderer.readRenderTargetPixels(rt, 0, 0, rt.width, rt.height, data);

        const flippedData = new Uint8Array(rt.width * rt.height * 4);
        for (let y = 0; y < rt.height; ++y) {
            for (let x = 0; x < rt.width; ++x) {
                let flippedY = rt.height - 1 - y;
                for (let c = 0; c < 4; ++c) {
                    let i = (y * rt.width + x) * 4 + c, j = (flippedY * rt.width + x) * 4 + c;
                    flippedData[i] = data[j];
                }
            }
        }

        // Create a 2D canvas to store the result 
        const canvas = document.createElement("canvas");
        canvas.width = rt.width;
        canvas.height = rt.height;
        const context = canvas.getContext("2d");
        if (!context) return "";

        // Copy the pixels to a 2D canvas
        const imageData = context.createImageData(rt.width, rt.height);
        imageData.data.set(flippedData);
        context.putImageData(imageData, 0, 0);

        const b64 = canvas.toDataURL();
        canvas.remove();
        return b64;
    }

    static isMesh(object: Object3D): object is Mesh {
        return (object as Mesh).isMesh;
    }
}
